import _classCallCheck from "D:\\William\\site\\actif conseil\\organigramme\\neby\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\William\\site\\actif conseil\\organigramme\\neby\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\William\\site\\actif conseil\\organigramme\\neby\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\William\\site\\actif conseil\\organigramme\\neby\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\William\\site\\actif conseil\\organigramme\\neby\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { ShaderMaterial, UniformsUtils } from 'three';
import { Pass, FullScreenQuad } from './Pass.js';

var ShaderPass =
/*#__PURE__*/
function (_Pass) {
  _inherits(ShaderPass, _Pass);

  function ShaderPass(shader, textureID) {
    var _this;

    _classCallCheck(this, ShaderPass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShaderPass).call(this));
    _this.textureID = textureID !== undefined ? textureID : 'tDiffuse';

    if (shader instanceof ShaderMaterial) {
      _this.uniforms = shader.uniforms;
      _this.material = shader;
    } else if (shader) {
      _this.uniforms = UniformsUtils.clone(shader.uniforms);
      _this.material = new ShaderMaterial({
        defines: Object.assign({}, shader.defines),
        uniforms: _this.uniforms,
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader
      });
    }

    _this.fsQuad = new FullScreenQuad(_this.material);
    return _this;
  }

  _createClass(ShaderPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive */
    ) {
      if (this.uniforms[this.textureID]) {
        this.uniforms[this.textureID].value = readBuffer.texture;
      }

      this.fsQuad.material = this.material;

      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer); // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600

        if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        this.fsQuad.render(renderer);
      }
    }
  }]);

  return ShaderPass;
}(Pass);

export { ShaderPass };